import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import FirmInfo from "./firmInfo";
import UserInfo from "./userInfo";
import { FormattedMessage, useIntl } from "react-intl";
import { StandardTabs, Tab, /* Checkbox,*/ Button } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getSettingsCompany, getSettingsCompanyForUser } from "../../store/actions/permissions";
import useChangeCompany from "../../customHooks/useChangeCompany";
import useChangeAccountant from "../../customHooks/useChangeAccountant";
import { TSID_PUBLIC_URL } from "../../config";

const Cliente = () => {

  const {changeCompanySelected} = useChangeCompany();
  const {changeAccountantSelected} = useChangeAccountant();

  const company = useSelector(state => state.company);
  const main = useSelector(state => state.main);
  const user = useSelector(state => state.user);
  const companyList = company?.companies;

  const intl = useIntl();

  const userUuidSelected = user?.profile?.uuid ? user?.profile?.uuid : user?.profile?.id;
  const accountantIdSelected = main.accountantIdSelected;
  const companySelected = main.companySelected;
  const companyObj = company.companies.find(el => {
    return el.codiceFiscale === companySelected;
  });

  const commercialistiList = companyObj.commercialistiList;

  const [activeTab, setActiveTab] = useState(0);
  const [companySel /* setCompanySel*/] = useState(companySelected);
  const [accountantSel /* setAccountantSel*/] = useState(accountantIdSelected);

  const dispatch = useDispatch();

  const renderPersonalInfo = () => {
    return <UserInfo user={user} />;
  };

  const renderStudioInfo = infoMyCompany => {
    return (
      <FirmInfo
        fromClient={true}
        infoMyCompany={infoMyCompany}
        companySel={companySel}
      />
    );
  };

  const handleTabChange = e => {
    setActiveTab(e);
  };

  useEffect(() => {
    if (companySel !== companySelected) {
      dispatch(getSettingsCompany(companySel));
      dispatch(getSettingsCompanyForUser(
        companySel,
        userUuidSelected,
        accountantIdSelected
      ));
      changeCompanySelected(companySel);
      changeAccountantSelected(accountantSel);
    }
  }, [companySel]);

  useEffect(() => {
    if (accountantSel !== accountantIdSelected) {
      dispatch(getSettingsCompany(companySel));
      dispatch(getSettingsCompanyForUser(
        companySel,
        userUuidSelected,
        accountantIdSelected
      ));
      changeAccountantSelected(accountantSel);
    }
  }, [accountantSel]);

  /* const changeCompany = idCompany => {
    setCompanySel(idCompany);
  };

  const changeStudio = idStudio => {
    setAccountantSel(idStudio);
  };*/

  const renderListCard = (
    itemList, idSelected, client
  ) => {
    let listCard = [];
    let color = "#09822a";

    if (itemList) {
      for (let s in itemList) {
        if (s) {
          let cardSelected = idSelected === itemList[s].codiceFiscale;
          cardSelected ? (color = "#09822a") : (color = "#d82829");
          listCard.push(<div
            className={
              cardSelected
                ? "cardSkeleton box1_3 profile selected"
                : "cardSkeleton box1_3 profile"
            }
            style={{
              width: "344px",
              maxHeight: "240px",
              minHeight: "240px",
              display: "flex"
            }}
          >
            <div style={{ display: "flex" }}>
              <div className={itemList[s].logoUrl ? "iconCardBack companyLogoProfile " : "iconCardBack"} style={{backgroundImage: itemList[s].logoUrl && `url(${itemList[s].logoUrl})`}}>
                { !itemList[s].logoUrl &&
                    <FontAwesomeIcon
                      icon={["far", "building"]}
                      className="iconCard"
                    />
                }
              </div>
              <div className="studioCard">{itemList[s].ragioneSociale}</div>
              {/* <div
                style={{
                  marginRight: "10px",
                  marginTop: "10px",
                  marginLeft: "auto"
                }}
              >
                <Checkbox
                  onChange={() => {
                    if (client) {
                      changeCompany(itemList[s].id);
                    } else {
                      changeStudio(itemList[s].id);
                    }
                  }}
                  checked={cardSelected ? true : false}
                ></Checkbox>
                </div>*/}
            </div>
            <div
              style={{
                alignSelf: "flex-end",
                fontSize: "10px",
                marginRight: "10px"
              }}
            >
              {cardSelected ? intl.formatMessage({id: "generic.active"}) : intl.formatMessage({id: "generic.notActive"})}
              <FontAwesomeIcon
                icon={["fas", "circle"]}
                style={{ color: color, marginLeft: "7px", fontSize: "8px" }}
              />
            </div>
            <div className="studioCardFooter">
              {renderStudioInfo(itemList[s])}
            </div>
          </div>);
        }
      }
    } else {
      return (
        <div
          className="azureFont lightFont"
          style={{ fontSize: "25px", width: "100%", marginTop: "20px" }}
        >
          <FormattedMessage id="profile.noAccountant" />
        </div>
      );
    }
    return listCard;
  };

  let cognomeNome = user.profile.lastName
    ? user.profile.lastName + " " + user.profile.firstName
    : "N/A";

  return (
    <div>
      <StandardTabs
        style={{ marginBottom: "5px", overflow: "hidden", width: "100%" }}
        activeIndex={activeTab}
        onChange={handleTabChange}
      >
        <Tab className="styleTab" key={0}>
          <FormattedMessage id="profile.profile" />
        </Tab>
        <Tab className="styleTab" key={1}>
          <FormattedMessage id="profile.professionalStudies" />
        </Tab>
      </StandardTabs>
      {activeTab === 0 ? (
        <div>
          <div
            className="profile-header-refactor"
            style={{ display: "flex", marginTop: "40px", marginLeft: "30px" }}
          >
            <div className="shortNameRound">
              {cognomeNome
                .split(" ")
                .map(function(s) {
                  return s.charAt(0);
                })
                .join("")
                .substr(0, 2)}
            </div>
            <div style={{ float: "right", marginLeft: "30px" }}>
              {renderPersonalInfo()}
            </div>
            <div>
              <a href={TSID_PUBLIC_URL}
                target="_blank"
                id="goToTSDigital"
                aria-label={"Accedi all'area personale"}
                tabIndex="0" rel="noreferrer">
                <Button kind="secondary">
                  <FormattedMessage id="profile.personalArea"/>
                </Button>
              </a></div>
          </div>
          <div style={{ display: "flex", marginLeft: "30px", flexWrap: "wrap" }}>
            {" "}
            {renderListCard(
              companyList, companySelected, true
            )}
          </div>
        </div>
      ) : (
        <div style={{ display: "flex", marginLeft: "30px", marginTop: "40px" }}>
          {" "}
          {renderListCard(
            commercialistiList, accountantIdSelected, false
          )}
        </div>
      )}
    </div>
  );
};

export default Cliente;
